import { formatExecutionValue } from '@/utils/automationExecutionChange';

export function pendingRunValueText(value: unknown, total: number): string {
  const text = formatExecutionValue(value);
  if (total <= 1) return text;
  return `${text} +${total - 1} more`;
}

export function pendingRunNamePreview(names: string[], total: number): string {
  const preview = names.slice(0, 2).join(', ');
  if (total <= 2) return preview;
  return `${preview} +${total - 2}`;
}
